<!--
 * @Author: wenpan.cao@ecarxgroup.com
 * @Date: 2022-09-26 10:22:53
 * @LastEditTime: 2022-10-24 17:20:35
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @Description: 描述
-->

<template>
  <div :title="value"
    widget-type="dateRange">
    <label v-if="isNested && disabled">{{value}}</label>
    <template v-else>
      <a-range-picker
        :disabledDate="disabledDate"
        :size="size"
        v-model="text"
        :show-time="options.type === 'dateTime' ? { format: 'HH:mm:ss' } : false"
        :data-model="fieldName"
        :disabled="disabled"
        :placeholder="disabled ? [] : rangePlaceholder"
        :format="transFormat(options.format)"
        :class="options.customClass"
        :picker="options.type === 'dataTime' ? 'date' : options.type"
        :allowClear="options.clearable"
        @change="handleChange" />
        <!-- :picker="options.type === 'dataTime' ? 'date' : options.type" 此用法在3.0版本生效 -->
    </template>
  </div>
</template>
<script>
import moment from 'moment';
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
  data() {
    return {
      disabledDate: null,
      options: {
        defaultValue: [],
        readonly: false,
        disabled: false,
        editable: true,
        clearable: true,
        placeholder: '',
        startPlaceholder: '',
        endPlaceholder: '',
        type: 'date',
        format: 'YYYY-MM-DD',
        timestamp: false,
        required: false,
        width: '',
        customClass: '',
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
        remoteFunc: '',
        remoteOption: '',
      },
    };
  },
  methods: {
    moment,
    setDisabledDate(fn) {
      this.disabledDate = fn;
    },
    initVal(val) {
      const momentArr = val.split(',');
      if (momentArr.length > 1) {
        const { format } = this.options;
        this.text = [moment(momentArr[0], format), moment(momentArr[1], format)];
      } else {
        this.text = [undefined, undefined];
      }
    },
    handleChange(val) {
      let newVal = val;
      const { format, type } = this.options;
      if (val.length) {
        newVal = [val[0].format(format), val[1].format(format)].join(',');
      }
      if (!this.isNested) {
        const { rowIndex, fieldName: field } = this;
        const value = {
          type,
          rowIndex,
          field,
          value: newVal,
        };
        this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
      }
      // 将数据抛给上一层，主要是被子表格服务
      this.$emit('change', newVal);
    },
  },
};
</script>
